import AnchoredPopover from '../../generic/AnchoredPopover';
import * as style from './ProductTags.module.css';

export interface Props {
    tags?: Sticker[];
}

export interface Sticker {
    description: string;
    group: { color: string };
    imageUrl: string;
    icon:
        | 'biodynamic'
        | 'eco'
        | 'environmentmarking'
        | 'environmentpackaging'
        | 'fairtrade'
        | 'gluten'
        | 'kosher'
        | 'naturalwine'
        | 'orangewine'
        | 'vegan'
        | 'sweetwine';
    sustainability: boolean;
    title: string;
}

export default function ProductTags({ tags }: Props) {
    if (!tags?.length) {
        return null;
    }
    return (
        <ul className={style.tagList}>
            {tags.map((tag) => (
                <Tag key={tag.title} {...tag} />
            ))}
        </ul>
    );
}

function Tag({ title, imageUrl, description, group }: Sticker) {
    return (
        <li style={{ '--tag-color': group.color }}>
            <AnchoredPopover className={style.popup} id={`popover-tag-${title}`} data-modal-name="ProductTag" buttonChildren={title}>
                <h2>
                    {title}
                    <img className={style.stickerIcon} src={imageUrl} />
                </h2>
                <p>{description}</p>
            </AnchoredPopover>
        </li>
    );
}
